import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';
import * as urlUtils from 'utils/url';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/survey_template_categories`,
};

class SurveyTemplateCategoryApi {
  /**
   * gets all categories
   */
  static getAll(dropdown) {
    const URL = urlUtils.addQueryParameters(URLS.INDEX, { dropdown });
    return AuthenticatedRequestService.get(URL);
  }
}

export default SurveyTemplateCategoryApi;



// WEBPACK FOOTER //
// ./src/apis/surveys/SurveyTemplateCategory.js